import React from 'react';
import { Table } from 'react-bootstrap';
import ReportHeader from './report_header';
import { ReturnNoteType } from '../../shared/models/returnNoteModels';
import { ReportType } from '../../shared/models/reportModels';
import { get } from 'lodash';

const report1Columns = [{
  id: 'Product',
  name: 'Product'
},
{
  id: 1,
  name: 'Time'
}];

const report2Columns = [{
    id: 'Product',
    name: 'Product'
},
{
    id: '1',
    name: 'Awaiting Inspection (col 1) to Inspection in Progress (col 2)'
},
{
    id: '2',
    name: 'Inspection in Progress (col 2) to Awaiting Parts (col 3)'
},
{
    id: '3',
    name: 'Awaiting Parts (col 3) to Awaiting Order Number (col 4)'
},
{
    id: '4',
    name: 'Awaiting Order Number (col 4) to Awaiting Payment (Col 5)'
},
{
    id: '5',
    name: 'Awaiting Payment (Col 5) to B.E.R. (col 6)'
},
{
    id: '6',
    name: 'B.E.R. (col 6) to Order Number or Payment Received (col 7)'
},
{
    id: '7',
    name: 'Order Number or Payment Received (col 7) to Repair in Progress (col 8)'
},
{
    id: '8',
    name: 'Repair in Progress (col 8) to Awaiting Dispatch (col 9)'
},
{
    id: '9',
    name: 'Awaiting Dispatch (col 9) to Dispatched (col10)'
}
];

const report3Columns = [{
    id: 'Product',
    name: 'Product'
},
{
    id: 1,
    name: 'Customer Name'
}, {
    id: 2,
    name: 'Serial Number'
},
{
    id: 3,
    name: 'Time in Repair'
}];

const report4Columns = [
  { id: 'year', name: 'Year' },
  { id: 'month', name: 'Month' },
  { id: 'qty', name: 'Quantity' }
];

const report5Columns = [
  { id: 'year', name: 'Year' },
  { id: 'month', name: 'Month' },
  { id: 'qty', name: 'Quantity' },
  { id: 'productName', name: 'Product Name' }
];

const report6Columns = [
  { id: 'product', name: 'Product' },
  { id: 'c1', name: 'Awaiting Inspection' },
  { id: 'c2', name: 'Inspection In Progress' },
  { id: 'c3', name: 'Awaiting Parts' },
  { id: 'c4', name: 'Awaiting Order Number' },
  { id: 'c5', name: 'Awaiting Payment' },
  { id: 'c6', name: 'BER' },
  { id: 'c7', name: 'Order/Payment Received' },
  { id: 'c8', name: 'Repair In Progress' },
  { id: 'c9', name: 'Awaiting Dispatch' },
  { id: 'c10', name: 'Dispatched' }
];

interface IProps {
    reportForm: any;
    reportDetail: any;
}

const ReportDetail = ({ reportForm, reportDetail }: IProps) => {
    const { reportEnum } = reportForm;

    const getProductTypes = (id: number) => {
        if (id === ReturnNoteType.GasMixer) {
            return 'Gas Mixer'
        } else if (id === ReturnNoteType.GasAnalyser) {
            return 'Gas Analyser'
        } else if (id === ReturnNoteType.LeakDetection) {
            return 'Leak Detection'
        } else {
            return ''
        }
    }

const getTimeString = (row: any) => {
    if (!row) return '';

    if (typeof row === 'string') {
        return row;
    }

    const day = row.day ?? row.Day ?? 0;
    const hour = row.hour ?? row.Hour ?? 0;
    const minute = row.minute ?? row.Minute ?? 0;

    return `${day} days, ${hour} hours, ${minute} minutes`;
}

    return <div>
        {reportEnum === ReportType.ColumnReport && <Table bordered size="sm">
            <ReportHeader
                reportForm={reportForm}
                columns={report2Columns}
            />
            <tbody>
                {reportDetail.map((row, index) =>
                    <tr key={index}>
                        <td>{row.productName}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col1'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col2'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col3'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col4'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col5'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col6'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col7'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col8'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col9'))}</td>
                    </tr>)}
            </tbody>
        </Table>}

        {reportEnum === ReportType.RepairInProgress && <Table bordered size="sm" >
            <ReportHeader reportForm={reportForm} columns={report3Columns} />
            <tbody>
                {reportDetail.map((row, index) =>
                    <tr key={index}>
                        <td>{row.productName}</td>
                        <td>{row.customerName}</td>
                        <td>{row.serialNo}</td>
                        <td>{getTimeString(row)}</td>
                    </tr>
                )}
            </tbody>
        </Table>}

        {reportEnum === ReportType.ProductReport && <Table bordered size="sm" >

            <ReportHeader reportForm={reportForm} columns={report1Columns} />

            <tbody>
                {reportDetail.map((row, index) =>
                    <tr key={index}>
                        <td>{getProductTypes(row.id)}</td>
                        <td>{getTimeString(row)}</td>
                    </tr>
                )}
            </tbody>
        </Table>}

        {reportEnum === ReportType.UnitsPerMonth && (
  <Table bordered size="sm">
    <ReportHeader reportForm={reportForm} columns={report4Columns} />
    <tbody>
      {reportDetail.map((row, index) => (
        <tr key={index}>
          <td>{row.year}</td>
          <td>{row.month}</td>
          <td>{row.qty}</td>
        </tr>
      ))}
    </tbody>
  </Table>
)}

  {reportEnum === ReportType.UnitsPerMonthByProductType && (
  <Table bordered size="sm">
    <ReportHeader reportForm={reportForm} columns={report5Columns} />
    <tbody>
      {reportDetail.map((row, index) => (
        <tr key={index}>
          <td>{row.year}</td>
          <td>{row.month}</td>
          <td>{row.qty}</td>
          <td>{row.productName}</td>
        </tr>
      ))}
    </tbody>
  </Table>
)}

{reportEnum === ReportType.AverageTimeInStatus && (
  <Table bordered size="sm">
    <ReportHeader reportForm={reportForm} columns={report6Columns} />
    <tbody>
      {reportDetail.map((row, index) => (
        <tr key={index}>
          <td>{row.productName}</td>
          <td>{getTimeString(row.awaitingInspection)}</td>
          <td>{getTimeString(row.inspectionInProgress)}</td>
          <td>{getTimeString(row.awaitingParts)}</td>
          <td>{getTimeString(row.awaitingOrderNumber)}</td>
          <td>{getTimeString(row.awaitingPayment)}</td>
          <td>{getTimeString(row.ber)}</td>
          <td>{getTimeString(row.orderNumberOrPaymentReceived)}</td>
          <td>{getTimeString(row.repairInProgress)}</td>
          <td>{getTimeString(row.awaitingDispatch)}</td>
          <td>{getTimeString(row.dispatched)}</td>
        </tr>
      ))}
    </tbody>
  </Table>
)}
    </div>
}

export default ReportDetail;